var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 718,
    height: 718,
    viewBox: "0 0 718 718",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.516 10.4806C349.135 -3.23835 368.865 -3.23838 376.484 10.4806L441.449 127.45C445.965 135.58 455.488 139.525 464.43 136.969L593.077 100.196C608.166 95.8833 622.117 109.834 617.804 124.923L581.031 253.57C578.475 262.512 582.42 272.035 590.55 276.551L707.519 341.516C721.238 349.135 721.238 368.865 707.519 376.484L590.55 441.449C582.42 445.965 578.475 455.488 581.031 464.43L617.804 593.077C622.117 608.166 608.166 622.117 593.077 617.804L464.43 581.031C455.488 578.475 445.965 582.42 441.449 590.55L376.484 707.519C368.865 721.238 349.135 721.238 341.516 707.519L276.551 590.55C272.035 582.42 262.512 578.475 253.57 581.031L124.923 617.804C109.834 622.117 95.8833 608.166 100.196 593.077L136.969 464.43C139.525 455.488 135.58 445.965 127.45 441.449L10.4806 376.484C-3.23835 368.865 -3.23838 349.135 10.4806 341.516L127.45 276.551C135.58 272.035 139.525 262.512 136.969 253.57L100.196 124.923C95.8833 109.834 109.834 95.8833 124.923 100.196L253.57 136.969C262.512 139.525 272.035 135.58 276.551 127.45L341.516 10.4806Z",
    fill: "#FABC1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.bb047da534b9aea18fc5ce47a095886c.svg";
export { ForwardRef as ReactComponent };